import React from 'react';

import OccupancyPopup from 'components/OccupancyPopup';

const Input = ({
    value,
    popup,
    openPopup,
    closePopup,
    className,
    changeRoomCount,
    changeAdultsCount,
    changeChildrenCount,
    changeChildAge,
    fullWidth,
}) => (
    <div>
        <label className={`${className}__label`} onClick={openPopup}>
            {value}
        </label>
        {popup && (
            <OccupancyPopup
                changeRoomCount={changeRoomCount}
                changeAdultsCount={changeAdultsCount}
                changeChildrenCount={changeChildrenCount}
                changeChildAge={changeChildAge}
                close={closePopup}
                fullWidth={fullWidth}
            />
        )}
    </div>
);

export default Input;
